<template>
  <template v-if="isRawPage"><RouterView /></template>
  <template v-else>
    <Header />
    <section class="page-body">
      <LeftSide />
      <section class="page-content">
        <Breadcrumb />
        <main><RouterView /></main>
      </section>
    </section>
  </template>
</template>

<script setup>
import Header from '@/components/header'
import LeftSide from '@/components/leftSide'
import Breadcrumb from '@/components/breadcrumb'
import * as Utils from '@/assets/utils'
import { onMounted } from 'vue'

  const pathName = window.location.pathname.replace('/', '')
  const isRawPage = [ 'login' ].includes(pathName)

  onMounted(() => {
    const userInfo = Utils.user.getInfo()
    if (!userInfo && !isRawPage) {
      Utils.user.logout()
      window.location.href = '/login'
    }
  })
</script>

<style lang="less">
  *{
    margin: 0;
    padding: 0;
  }
  html, body{
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 14px;
    color: #333333;
  }
  #app {
    height: 100vh;
  }
  .page-body{
    display: flex;
    flex: 1;
  }
  .page-content{
    flex: 1;
    padding: 24px;
    height: calc(~"100vh - 56px");
    overflow: auto;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;

    main{
      flex: 1;
      overflow: auto;
      display: flex;
      flex-direction: column;
    }
  }
</style>
